"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementPeriodRequestStatus = void 0;
var ManagementPeriodRequestStatus;
(function (ManagementPeriodRequestStatus) {
    ManagementPeriodRequestStatus["PENDING_PRICE_PROPOSAL"] = "PENDING_PRICE_PROPOSAL";
    ManagementPeriodRequestStatus["PRICE_PROPOSED"] = "PRICE_PROPOSED";
    ManagementPeriodRequestStatus["PRICE_ACCEPTED"] = "PRICE_ACCEPTED";
    ManagementPeriodRequestStatus["PRICE_REJECTED"] = "PRICE_REJECTED";
    ManagementPeriodRequestStatus["CANCELED"] = "CANCELED";
})(ManagementPeriodRequestStatus = exports.ManagementPeriodRequestStatus || (exports.ManagementPeriodRequestStatus = {}));
//# sourceMappingURL=HlManagementPeriodRequest.js.map